module.exports = __webpack_public_path__ + "static/media/v-Vinculum.1323a39b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v-Vinculum.png
// module id = 190
// module chunks = 0